<template>
    <div class="manage-name-move">
        <template v-if="noEdit">
            <div class="manage-name-move-div" @mouseenter="editShow" @mouseleave="editShow">
                <div :title="name" class="manage-name-move-div-name textEllipsis">{{ nameTemp == ''? '--':nameTemp }}</div>
                <Icon class="manage-name-move-div-edit" type="ios-create-outline" v-show="showEdit" @click.native.stop="startEdit" size="16"></Icon>
            </div>
        </template>
        <template v-else>
            <div class="manage-name-move-div">
              <Dropdown trigger="custom" :visible="visible" @on-click="setChangeName" transfer>
                    <i-input style="width:200px;" @keyup.native="setSearchData" v-model="changeName" @click.native="handleOpen"></i-input>
                    <Dropdown-menu slot="list">
                        <div v-if="list.length > 0" class="manage-name-move-div-list">
                            <Dropdown-item :name="item.partnerName" :title="item.partnerName" v-for="item in list" :key="item.partnerName">{{ item.partnerName }}</Dropdown-item>
                        </div>
                        <div v-else class="manage-name-move-div-nodata" style="height: 146px">{{ noData }}</div>
                        <div class="manage-name-move-div-btn">
                            <i-button type="text" @click="closeEdit">{{$t('common.cancel')}}</i-button>
                            <i-button type="primary" @click="changeChannelName">{{$t('common.certain')}}</i-button>
                        </div>
                    </Dropdown-menu>
              </Dropdown>
            </div>
        </template>
    </div>
</template>
<script>
import bus from '../../libs/bus';
import $ from '../../libs/util';
import { directive as clickoutside } from 'v-click-outside-x';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    partnerid: {
      type: String,
      default: '',
    },
  },
  directives: {
    clickoutside,
  },
  data() {
    return {
      showEdit: false,
      noEdit: true,
      changeName: '',
      visible: false,
      noData: this.$t('common.nodata'),
      nameList: bus.listname,
      saveNameList: JSON.stringify(bus.listname),
      nameTemp: this.name,
    };
  },
  computed: {
    list() {
      const list = [];
      for (let i = 0; i < this.nameList.length; i += 1) {
        if (bus.platform.toString() === '1') { // android
          if (this.nameList[i].android) list.push(this.nameList[i]);
        } else if (bus.platform.toString() === '2') { // ios
          if (this.nameList[i].ios) list.push(this.nameList[i]);
        } else if (bus.platform.toString() === '16') { // H5
          if (this.nameList[i].h5) list.push(this.nameList[i]);
        }
      }

      return list;
    },
  },
  watch: {
    name(param) {
      this.nameTemp = param;
    },
  },
  mounted() {
    const self = this;
    bus.$on('on-close-edit', (id) => {
      if (id !== self.partnerid) self.closeEdit();
    });
  },
  beforeDestroy() {
    bus.$off('on-close-edit');
  },
  methods: {
    editShow() {
      this.showEdit = !this.showEdit;
    },
    startEdit() {
      const self = this;
      self.noEdit = false;
      self.$nextTick(() => {
        this.$emit('on-change-channel-edit', this.partnerid);
      });
    },
    handleOpen() {
      this.visible = true;
    },
    closeEdit() {
      this.noEdit = true;
      this.visible = false;
      this.showEdit = false;
      this.changeName = '';
      this.nameList = bus.listname;
      this.saveNameList = JSON.stringify(bus.listname);
      this.noData = this.$t('common.nodata');
    },
    setSearchData() {
      const self = this;
      const newData = JSON.parse(this.saveNameList);
      const str = this.changeName.toLowerCase();
      if (str === '') {
        self.nameList = newData;
      } else {
        for (let i = 0; i < newData.length; i += 1) {
          const index = newData[i].partnerName.toLowerCase().indexOf(str);
          if (index === -1) {
            newData.splice(i, 1);
            i -= 1;
          }
        }
        self.nameList = newData;
      }
    },
    setChangeName(name) {
      this.changeName = name;
    },
    changeChannelName() {
      /*
      ** demo环境下不允许增删改
      **/
      if (bus.demoTip()) return;
      const a = `servertype=13&partnerid=${bus.setEncode(this.partnerid)}&`;
      const b = `newName=${this.changeName}&productid=${bus.setEncode(bus.productInfo.productid)}`;
      const c = `&platformid=${bus.setEncode(bus.platform.toString())}`;
      // 修改渠道名称 servertype=13&partnerid=&newName=123&productid=&platformid=
      //0~16个字符，可使用中文、字母、数字、下划线、中划线
      const reg = new RegExp('^[-A-Za-z0-9_\u4e00-\u9fa5]{0,16}$');
      if (!reg.test(this.changeName)) {
        this.$Message.destroy();
        this.$Message.error({
          content: this.$t('common.channelNameLength'),
          duration: 3,
        });
      } else {
        $.ajax.post('app/servlet/PartnerServlet', `${a}${b}${c}`)
          .then((res) => {
            if (res) {
              this.nameTemp = this.changeName;
              this.$emit('on-change-name-succ', this.partnerid, this.changeName);
              this.closeEdit();
            }
          }).catch(() => {
            this.$Message.error({
              content: this.$t('common.fail'),
              duration: 5,
            });
          });
      }
    },
  },
};
</script>
